import { render } from "./TanaoroshiAdjustmentDialog.vue?vue&type=template&id=0d4b83a2"
import script from "./TanaoroshiAdjustmentDialog.vue?vue&type=script&lang=js"
export * from "./TanaoroshiAdjustmentDialog.vue?vue&type=script&lang=js"

import "./TanaoroshiAdjustmentDialog.vue?vue&type=style&index=0&id=0d4b83a2&lang=css"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__